var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[(_vm.globals.publicConfig && _vm.globals.publicConfig.website && _vm.globals.publicConfig.website.showHeader)?_c('Header'):_vm._e(),_c('router-view',{key:_vm.$route.name + (_vm.$route.params.wikiname || '')}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }